export class Review {
  agent: string;
  name: string;
  rating: string;
  reviewText: string;
  bookedBy: string;
  agentSuffix: string;
  created: Date;
}
